var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-item item--collaborate"},[_c('div',{staticClass:"item"},[_c('collaborate-label',{attrs:{"instance":_vm.item}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }